/**
 * Registry of realtime event type identifiers (must match MainBundle\Model\RealtimeEventType).
 */
export const REALTIME_EVENT_VERSION = '1.0';

export const REALTIME_EVENT_TYPES = {
  EDITION_PREVIEW_UPDATED: 'edition.preview.updated',
  EDITION_PRINT_JOB_COMPLETED: 'edition.print_job.completed',
  ORDER_STATUS_CHANGED: 'order.status.changed',
  CART_VALIDATION_CHANGED: 'cart.validation.changed',
  LEAD_PIPELINE_UPDATED: 'lead.pipeline.updated',
};

/**
 * Build entity room name for subscribe/unsubscribe (matches PHP RealtimeEvent::entityRoom).
 *
 * @param {string} entityType
 * @param {string} entityId
 * @returns {string}
 */
export function entityRoom(entityType, entityId) {
  return `entity:${entityType}:${entityId}`;
}
